module.exports = __webpack_public_path__ + "img/ALC068-1-EN.4a1d5535.jpg";